import { FaCaretDown } from "react-icons/fa";

import {
  SiDiscord,
  SiGithub,
  SiTelegram,
  SiX,
} from "@icons-pack/react-simple-icons";

import { Button } from "shared/ui/button";
import { Popover } from "shared/ui/popover";

import { HeaderLink } from "../header-link";
import { SocialLink } from "./social-link";

const socialLinks = [
  {
    to: "/",
    icon: <SiX />,
  },
  {
    to: "/",
    icon: <SiDiscord />,
  },
  {
    to: "/",
    icon: <SiTelegram />,
  },
  {
    to: "/",
    icon: <SiGithub />,
  },
];

export const Menu = () => {
  return (
    <Popover>
      <Popover.Trigger asChild>
        <Button
          variant="transparent"
          className="w-32.5 justify-start gap-x-1.5 p-2.5"
        >
          <img className="size-auto" src="/bento-logo-white.svg" />
          <FaCaretDown className="text-nobel ml-auto size-3" />
        </Button>
      </Popover.Trigger>
      <Popover.Content align="start" sideOffset={14} className="items-start">
        <ul className="flex flex-col items-start gap-1.5">
          <HeaderLink className="px-3.5 py-2.5 text-base" to="/">
            Pre-Deposit
          </HeaderLink>
          <HeaderLink className="px-3.5 py-2.5 text-base" to="/portfolio">
            Portfolio
          </HeaderLink>
        </ul>

        <ul className="mt-6 flex gap-6 px-1.5">
          {socialLinks.map((link) => {
            return (
              <SocialLink key={link.to} href={link.to}>
                {link.icon}
              </SocialLink>
            );
          })}
        </ul>
      </Popover.Content>
    </Popover>
  );
};
